<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="academia-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            بطاقات Academia
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img
              class="icon-img text-center"
              src="assets/img/acad-icon.png"
              alt=""
            />
          </div>
          <h4 class="mb-2 text-center support-text">
            <div class="mb-2">بطاقات أكاديميا | Academia</div>
            <br />
            <span style="color: #9d9d9d"> أدخل أدناه بيانات البطاقة </span>
          </h4>
          <form @submit.prevent="handleSubmit" class="form-horizontal">
            <div class="row" dir="rtl">
              <div class="col-md-12">
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <label for="academia-code">رمز التعبئة </label>
                  <input
                    type="text"
                    class="form-control"
                    id="academia-code"
                    v-model="code"
                    placeholder="XXXXXXXXX"
                  />
                </div>
                <div class="mt-2"></div>
              </div>
            </div>
            <hr />
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              عودة
            </button>
            <button
              class="btn btn-success waves-effect waves-light btn-charge float-end"
              type="submit"
              :disabled="isLoading"
            >
              تعبئة <i class="fa fa-plus"></i>
              <span
                v-if="isLoading"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure

export default {
  name: "Academia",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
    };
  },
  mounted() {
    $("#academia-modal").on("show.bs.modal", () => {
      //$("#payments-modal").modal("hide");
      var myModal = new bootstrap.Modal(
        document.getElementById("payments-modal")
      );
      myModal.hide();
    });
  },
  methods: {
    handleSubmit() {
      this.academiaCharge();
    },
    async academiaCharge() {
      try {
        const result = await Swal.fire({
          title: "هل أنت متأكد من العملية؟",
          text: " ",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3ddc97",
          cancelButtonColor: "#f46a6a",
          cancelButtonText: "لا",
          confirmButtonText: "نعم",
        });

        if (result.isConfirmed) {
          this.isLoading = true;

          const response = await fetch(`${apiUrl}/vouchers/redeem`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.token}`,
            },
            body: JSON.stringify({ code: this.code }),
          });

          if (!response.ok) {
            const errorResponse = await response.json();
            throw errorResponse;
          }

          Swal.fire({
            icon: "success",
            title: "تم شحن المحفظة بنجاح",
            text: "",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;

        if (error.errors) {
          const errors = error.errors;
          if (errors.code === "هذا الكرت غير صالح") {
            Swal.fire("هذا الكرت غير صالح", "", "error");
          } else {
            Object.values(errors).forEach((errorMessage) => {
              Swal.fire("خطأ", errorMessage, "error");
            });
          }
        } else {
          Swal.fire("خطأ", "حدث خطأ ما. الرجاء المحاولة مرة أخرى.", "error");
        }
      }
    },
  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 100px;
}

#academia-code {
  text-align: center;
  border: 0px;
  background: #ededed;
  height: unset;
}

.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(0, 196, 68);
}
</style>
